import { DATA_PARASITE_LN_MODEL , LOCATE_ENDPOINT_VIEWEACH_KINDLAB , getBaseURLforBackEnd , getConfigAxios  }  from '@/utils.js'
import axios from "axios";
import master_data from "./master_data";



export default {
    namespaced: true,

    state: {

        buffPARADatPrepareDat : "", //buffBACTDatPrepareDat : "",
        
        buffPARADatCtDat : "",  // buffBACTDatCtDat : "",
        dataPARASpecLN: Object.assign( {} ,DATA_PARASITE_LN_MODEL) , // dataBACTSpecLN: Object.assign( {} ,DATA_PARASITE_LN_MODEL) ,

        mstPARADat: [] , // mstBactDat: [] ,
        mstDrugPARADat: [] , // mstDrugDat: [] ,
        mstMicPARADat  : [] , // mstMicDat  : [] ,
        mstResultPARADat: [], // mstResultDat: [],
        mstMethodPARA:[], // mstMethod:[],
        mstMethodPARAResult:[], // mstMethodResult:[],
        tmplatePARA:{} // tmplateBact:{}
    },

    getters: {

    },

    mutations: {
        setMstMethodPARA (state, mstMethodPARA) {
            state.mstMethodPARA = mstMethodPARA
        },


        setMstMethodPARAResult (state, mstMethodPARAResult) {
            state.mstMethodPARAResult = mstMethodPARAResult
        },

         


        setTmplatePARA (state, tmplatePARA) {
            state.tmplatePARA = tmplatePARA
        },


        setMstResultPARADat (state, mstResultPARADat) {
            state.mstResultPARADat = mstResultPARADat
        },

        setMstMicPARADat (state, mstMicPARADat) {
            state.mstMicPARADat = mstMicPARADat
        },

        setMstDrugPARADat (state, mstDrugPARADat) {
            state.mstDrugPARADat = mstDrugPARADat
        },

        setMstPARADat (state, mstPARADat) {
            state.mstPARADat = mstPARADat
        },


        setDataPARASpecLN (state, dataPARASpecLN) {
            state.dataPARASpecLN =  dataPARASpecLN
        },

        setBuffPARADatPrepareDat (state, buffPARADatPrepareDat) {
            state.buffPARADatPrepareDat = buffPARADatPrepareDat
        },

        setBuffPARADatCtDat (state, buffPARADatCtDat) {
            state.buffPARADatCtDat = buffPARADatCtDat
        },

    },

    actions: {
        // produceDoneFetching({commit},doneFetching){
        //     commit('setDoneFetching', doneFetching)
        // },

        
        // Dev experiment: HTTP-complete actions; legacy actions below are unchanged.
        fetchMiscMasterDataForPARASequential({
          commit
        }, datTo) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`;
          return axios.post(`${getBaseURLforBackEnd()}/api/getmiscmasterdataforparasite`, datTo, getConfigAxios()).then(res => {
            commit('setMstResultPARADat', res.data.result_mst);
            commit('setMstMicPARADat', res.data.mic);
            commit('setMstDrugPARADat', res.data.drug);
            commit('setMstPARADat', res.data.bact);
            commit('setTmplatePARA', res.data.tmplate);
            commit('setMstMethodPARA', res.data.method_mst);
            commit('setMstMethodPARAResult', res.data.method_result_mst);
            return res.data;
          });
        },
produceBuffPARADatPrepareDat({commit},buffPARADatPrepareDat){
            commit('setBuffPARADatPrepareDat', buffPARADatPrepareDat)
        },

        produceBuffPARADatCtDat({commit},buffDatCtDat){
            commit('setBuffPARADatCtDat', buffDatCtDat)
        },



        fetchMiscMasterDataForPARA({commit},datTo) {
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/getmiscmasterdataforparasite`,datTo,getConfigAxios())
                    .then((res)=>{
                        // console.log("fetchMiscMasterDataForPARA-->  ",res.data)
                        commit('setMstResultPARADat', res.data.result_mst)
                        commit('setMstMicPARADat', res.data.mic)
                        commit('setMstDrugPARADat', res.data.drug)
                        commit('setMstPARADat', res.data.bact)
                        commit('setTmplatePARA', res.data.tmplate)
                        commit('setMstMethodPARA', res.data.method_mst)
                        commit('setMstMethodPARAResult', res.data.method_result_mst)

                        resolve(res.data)
                    })
            }    )

        },


        fetchPARAOLDDat({commit}, payload) {
            const {shouldApply, ...datTo} = payload
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
            return axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_VIEWEACH_KINDLAB.PARASITE}`, datTo, getConfigAxios())
                .then(res => {
                    const prepare = res.data.dat_prepare.dat == null ? '' : Buffer.from(res.data.dat_prepare.dat, 'base64').toString('utf-8')
                    const ct = res.data.dat_ct.dat == null ? '' : Buffer.from(res.data.dat_ct.dat, 'base64').toString('utf-8')
                    if (shouldApply && !shouldApply()) return res.data
                    commit('setDataPARASpecLN', JSON.parse(JSON.stringify(res.data)))
                    commit('setBuffPARADatPrepareDat', prepare)
                    commit('setBuffPARADatCtDat', ct)
                    return res.data
                })
        }

    }
}